import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { decodeHtml } from "../../utils/decodeHtml";
function ActiveSearches() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [filterType, setFilterType] = useState("active");
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const navigate = useNavigate();
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [total_roles, settotal_roles] = useState(null);
  const [active_roles, setactive_roles] = useState(null);
  const [inactive_roles, setinactive_roles] = useState(null);
  const [closed_roles, setclosed_roles] = useState(null);

  const foptions = useRef();

  const columns = [
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 70,
      Cell: ({ row }) => {
        const name = row.original.role_name;
        return (
          <>
            <b>{name}</b>
          </>
        );
      },
    },
    {
      accessorKey: "company_name",
      header: "Clients",
      size: 70,
    },
    {
      accessorKey: "industrymaster",
      header: "Sector",
      size: 70,
    },
    {
      accessorKey: "industry",
      header: "Sub Sector",
      size: 70,
    },
    {
      accessorKey: "location",
      header: "Location",
      size: 70,
    },
    {
      accessorKey: "region_name",
      header: "Region",
      size: 70,
    },
    {
      accessorKey: "dutymaster",
      header: "Function",
      size: 70,
    },
    {
      accessorKey: "assignedTo",
      header: "Assigned To",
      size: 70,
    },
    {
      accessorKey: "role_manager",
      header: "Role Manager",
      size: 70,
    },
    {
      accessorKey: "expected_compensation",
      header: "Exp Comp",
      size: 70,
      Cell: ({ row }) => {
        const expected_compensation = row.original.expected_compensation || 0;
        const symbol = row.original.symbol || "";

        if (expected_compensation === 0) {
          return <>-</>;
        } else {
          return (
            <>
              {symbol} {Number(expected_compensation).toLocaleString("en-IN")}
            </>
          );
        }
      },
    },
    {
      accessorKey: "created_date",
      header: "Created Date",
      size: 70,
      Cell: ({ row }) => {
        const date = new Date(row.original.created_date);
        return <>{date.toLocaleDateString("en-CA")}</>;
      },
    },
  ];
  const fetchOptions = async () => {
    setGlobalLoading(true); //  Show loader before API call
    setOptionsLoaded(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/roles/active_searches/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setoptions(response.data.searches || []);
      console.log(response.data.searches);
    } catch (error) {
      setGlobalLoading(false);
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
    } finally {
      setOptionsLoaded(true);
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (foptions.current) return;
    foptions.current = true;
    fetchOptions();
  }, []);

  useEffect(() => {
    $('[name="role_search"]').select2({
      multiple: false,
      closeOnSelect: true,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/roles/roleLoad/`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          console.log(
            "Sending JSON:",
            JSON.stringify({ keywords: params.term }),
          ); // Debugging
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          console.log(data.options);
          if (!data.options || data.options.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.options.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Roles",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No Role found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='role_search']").on("change", function () {
      const selectedValues = $(this).val() || [];
      navigate(`/role/view/${selectedValues}`);
    });

    return () => {
      $("[name='role_search']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Active Searches</h2>
          </div>
        </div>

        <div className="card">
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <div className="row p-4 mt-3">
                <MaterialReactTable
                  columns={columns}
                  data={options || []}
                  state={{
                    isLoading: !optionsLoaded,
                  }}
                  initialState={{
                    density: "compact",
                    pagination: { pageSize: 30 },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActiveSearches;
